import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/pencil-icon.svg'


const _hoisted_1 = { class: "w-full p-3 bg-white rounded-primary-radius shadow-primary-box-shadow" }
const _hoisted_2 = { class: "text-xl leading-[32px] tracking-[0.01rem] text-primary-text-color pb-4 font-semibold" }
const _hoisted_3 = { class: "flex flex-col items-start gap-2 -ml-[3px]" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-base leading-5 font-normal tracking-[0.01rem] text-primary-text-color" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "text-base leading-5 font-normal tracking-[0.01rem] text-primary-text-color" }
const _hoisted_12 = {
  key: 0,
  class: "text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 1,
  class: "text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }

import { transformSlug } from "@/utils/transformSlug";

import { useTranslate } from "@/composables/useTranslate";

type Props = {
  step: any;
};

type Emits = {
  (
    event: "setSelectedInput",
    input: any,
    inputIndex?: number,
    groupInputIndex?: number
  ): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'MissingImageBlock',
  props: {
    step: {}
  },
  emits: ["setSelectedInput"],
  setup(__props: any) {

const props = __props;


const { t } = useTranslate();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)("phase.images")), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.step.inputs.filter((item)=> item.type === 'image' && item.showInMissingInputs && item.value.length === 0), (input) => {
        return (_openBlock(), _createElementBlock("div", {
          key: input.id,
          onClick: ($event: any) => (
          _ctx.$emit(
            'setSelectedInput',
            input,
            undefined,
            input.repeatableGroupIndex
          )
        ),
          class: "group border py-[3px] border-transparent hover:cursor-pointer hover:bg-[#F9F8F6] hover:border-[#E3E1EA] hover:rounded-[5px] w-full flex items-center gap-1"
        }, [
          _createElementVNode("h4", _hoisted_5, [
            (input.parentId !== null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  (__props.step.inputs.find((i) => i.id === input.parentId)?.repeatableGroupDetails)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(transformSlug)(
                  __props.step.inputs.find((i) => i.id === input.parentId)
                    ?.projectReference
                )
                  ? _unref(transformSlug)(
                      __props.step.inputs.find((i) => i.id === input.parentId)
                        ?.projectReference + ":"
                    )
                  : "") + " " + _toDisplayString(__props.step.inputs
                  .find((i) => i.id === input.parentId)
                  ?.repeatableGroupDetails.find(
                    (item) => item.order === input.repeatableGroupIndex + 1
                  )?.name) + " / ", 1))
                    : (__props.step.inputs.find((i) => i.id === input.parentId)?.repeatableInputNoun)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.step.inputs.find((i) => i.id === input.parentId)
                  ?.repeatableInputNoun + ` ${input.repeatableGroupIndex + 1}`) + " / ", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(__props.step.inputs.find((i) => i.id === input.parentId)?.name) + " /", 1))
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(input.name), 1)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            class: "w-3 h-3 mr-[5px] invisible group-hover:visible ml-auto",
            src: _imports_0,
            alt: "Icon"
          }, null, -1))
        ], 8, _hoisted_4))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.step.inputs.filter((item)=>
          (item.type === 'repeatable_input' && item.value.some((repValue) => repValue.value.length === 0))), (input) => {
        return (_openBlock(), _createElementBlock("div", {
          key: input.id,
          class: "flex flex-col"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.value.filter((val)=> val.value && val.value.length === 0), (repetableInput) => {
            return (_openBlock(), _createElementBlock("div", {
              key: repetableInput.index,
              class: "flex group border py-[3px] border-transparent hover:cursor-pointer hover:bg-[#F9F8F6] hover:border-[#E3E1EA] hover:rounded-[5px] w-full items-center gap-1",
              onClick: ($event: any) => (
            _ctx.$emit(
              'setSelectedInput',
              input,
              repetableInput.index,
              input.repeatableGroupIndex
            )
          )
            }, [
              _createElementVNode("h4", _hoisted_11, [
                (input.parentId !== null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      (__props.step.inputs.find((i) => i.id === input.parentId)?.repeatableGroupDetails)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(transformSlug)(
                    __props.step.inputs.find((i) => i.id === input.parentId)
                      ?.projectReference
                  )) + ": " + _toDisplayString(__props.step.inputs
                    .find((i) => i.id === input.parentId)
                    ?.repeatableGroupDetails.find(
                      (item) => item.id === input.repeatableGroupIndex + 1
                    )?.name) + " / ", 1))
                        : (__props.step.inputs.find((i) => i.id === input.parentId)?.repeatableInputNoun)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(__props.step.inputs.find((i) => i.id === input.parentId)
                    ?.repeatableInputNoun + ` ${input.repeatableGroupIndex + 1}`) + " / ", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(__props.step.inputs.find((i) => i.id === input.parentId)?.name) + " /", 1))
                    ]))
                  : _createCommentVNode("", true),
                (input.isConditionallyRepetable)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(input.name + ` ${repetableInput.index + 1}`), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(input.name) + " / ", 1),
                      _createTextVNode(" " + _toDisplayString(input.repeatableInputNoun + ` ${repetableInput.index + 1}`), 1)
                    ]))
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                class: "w-3 h-3 mr-[5px] invisible group-hover:visible ml-auto",
                src: _imports_0,
                alt: "Icon"
              }, null, -1))
            ], 8, _hoisted_10))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

})